import { render } from "./BookingAccordion.vue?vue&type=template&id=576c6a32"
import script from "./BookingAccordion.vue?vue&type=script&lang=js"
export * from "./BookingAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "576c6a32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('576c6a32', __exports__)) {
    api.reload('576c6a32', __exports__)
  }
  
  module.hot.accept("./BookingAccordion.vue?vue&type=template&id=576c6a32", () => {
    api.rerender('576c6a32', render)
  })

}


export default __exports__